import { bootstrapApplication } from "@angular/platform-browser";
import * as Sentry from "@sentry/angular";
import { browserTracingIntegration } from "@sentry/angular";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment";

Sentry.init({
    ...environment.sentry,
    integrations: [browserTracingIntegration()]
});

bootstrapApplication(AppComponent, appConfig).catch((error) => {
    console.error(error);
});
